<template>
  <div class="forgetContent">
    <div class="headers">
      <div>
        <img
          src="../../assets/img/login/tc-logo3.png"
          alt=""
          style="width:201px;vertical-align:middle;cursor:pointer;margin-left:100px;"
          @click="matinTap"
        />
      </div>
    </div>
    <div class="signindex">
      <p class="cont_head">
        {{$t('user.forgetpassword')}}
      </p>
      <div class="headerLogin">
        {{$t('user.already')}}
        <span
          class="cols"
          @click="loginTap"
        >{{$t('user.logintap')}}</span>
      </div>
      <div class="logincontent">
        <div class="headerTitle">
          <div
            :class="tapflag ? 'active' : 'one'"
            @click="tapphone"
          >
            {{$t('user.forgetphone')}}
          </div>
          <div
            :class="tapflags ? 'actives' : 'two'"
            @click="tapemail"
          >
            {{$t('user.forgetemail')}}
          </div>
        </div>
        <div
          class="formsign"
          v-if="tapflag"
        >
          <phone-find ref="phonefind"></phone-find>
        </div>
        <div
          class="formsign"
          v-else
        >
          <email-find ref="emailfind"></email-find>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import phoneFind from "@/components/user/phonefind";
import emailFind from "@/components/user/emailfind";
export default {
  components: {
    emailFind,
    phoneFind
  },
  data() {
    return {
      activeName: "first",
      signStatus: true,
      fastStatus: false,
      tapflag: true,
      tapflags: false
    };
  },
  methods: {
    matinTap() {
      this.$router.push({
        name: "main"
      });
    },
    loginTap() {
      this.$router.push({
        name: "login"
      });
    },
    handleClick(val) {
      if (val.name == "first") {
        this.signStatus = true;
      } else {
        this.fastStatus = true;
      }
    },
    tapphone() {
      this.tapflag = true;
      this.tapflags = false;
      this.phonefirstStap = true;
    },
    tapemail() {
      this.tapflag = false;
      this.tapflags = true;
      this.emailfirstStap = true;
      console.log(this.tapflags);
    }
  }
};
</script>
<style lang="scss">
.forgetContent {
  width: 100%;
  .headers {
    width: 100%;
    height: 104px;
    line-height: 104px;
    padding-top: 10px;
    text-align: left;
  }
  .signindex {
    width: 100%;
    // height: 100%;
    position: absolute;
    margin: 0 auto;
    .cont_head {
      font-size: 30px;
      padding-top: 20px;
      color: #333;
    }
    .headerLogin {
      margin-top: 18px;
      font-size: 16px;
      .cols {
        color: #1d5a33;
        font-size: 16px;
      }
      .cols:hover {
        color: #248f47;
        cursor: pointer;
      }
    }
    .logincontent {
      .headerTitle {
        width: 600px;
        height: 40px;
        line-height: 40px;
        margin: 30px auto;
        text-align: center;
        border: 1px solid #1d5a33;
        border-radius: 6px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        cursor: pointer;
        .one {
          width: 50%;
          height: 100%;
        }
        .two {
          width: 50%;
          height: 100%;
        }
        .active {
          width: 50%;
          height: 100%;
          background-color: #1d5a33;
          color: #fff;
          border-radius: 6px 0 0 6px;
        }
        .actives {
          width: 50%;
          height: 100%;
          background-color: #1d5a33;
          color: #fff;
          border-radius: 6px;
          border-radius:0 6px 6px 0;
        }
      }
      .content {
        margin-bottom: 30px;
      }
      .formsign {
        margin: auto;
        margin-top: 40px;
        display: flex;
        justify-content: center;
        .el-input__inner {
          border: 1px solid #1d5a33;
        }
        .picwid.el-input {
          width: 190px;
          .el-input__inner {
            width: 190px;
          }
        }
        .codewid {
          width: 100px;
          display: inline-block;
          img {
            width: 100%;
          }
        }
        .codes {
          text-align: center;
          font-size: 16px;
        }
        .codeImg {
          margin-top: 30px;
          text-align: center;
          img {
            width: 190px;
            height: 75px;
          }
        }
        .codesy {
          color: #26a2ff;
          text-align: center;
          position: absolute;
          left: 125px;
          font-size: 13px;
          width: 69px;
        }
        .kbq {
          font-size: 15px;
          margin-top: 20px;
          text-align: center;
          margin-bottom: 10px;
        }
        .el-steps--horizontal {
          padding: 0 40px;
          margin-top: 20px;
        }
        .el-form-item {
          margin-bottom: 20px;
        }
      }
      .signsuccess {
        display: flex;
        justify-content: center;
        align-content: center;
        padding-top: 100px;
        height: 520px;
        margin: auto;
        width: 1200px;
        border-bottom: 1px solid rgb(232, 232, 232);
        img {
          vertical-align: middle;
        }
        .logins {
          font-size: 12px;
          color: #999;
          margin-left: 50px;
        }
      }
    }
  }
  .el-dialog__body {
    text-align: center;
  }
  .elbtn {
    margin-top: 20px;
    padding-bottom: 30px;
    .rightBtn {
      width: 316px;
      margin-top: 14px;
      margin-left: 50px;
    }
  }
  .el-form-item__label {
    padding-right: 50px;
    // font-size: 16px;
    color: #1d5a33;
  }
  .posit {
    position: relative;
    .drag_verify {
      position: absolute;
      left: 50%;
      margin-left: -133px;
    }
  }
}
</style>
